import {CdkStepper} from '@angular/cdk/stepper';
import {HttpErrorResponse} from '@angular/common/http';
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Meta, Title} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
import {Documets, ErrorMessage, Spouse} from '../../applications/application/application';
import {AssistedService} from '../../applications/assisted.service';
import {ApplicationsService} from '../../applications/applications.service';
import {Attachment} from '../../core/models';

declare var $: any;

@Component({
  selector: 'app-apply-upload-documents',
  templateUrl: './apply-upload-documents.component.html',
  styleUrls: ['./apply-upload-documents.component.scss']
})
export class ApplyUploadDocumentsComponent implements OnInit {
  public validated: boolean;
  @ViewChild('documentForm', {static: false})
  public documentForm: NgForm;
  @Input() cdkStepper: CdkStepper;
  @BlockUI() blockUI: NgBlockUI;
  maxFileSize: number = 20971520;
  allowedFileTypes: string[] = [".png", ".jpg", ".jpeg", ".pdf", ".doc", ".docx"];
  documents: Documets = new Documets();
  errorMessage: ErrorMessage = new ErrorMessage();

  constructor(public activeModal: NgbActiveModal, protected assistedService: AssistedService,
              public applicationsService: ApplicationsService, private router: Router,
              protected gaService: GoogleAnalyticsService,
              private matSnackBar: MatSnackBar, public meta: Meta, public title: Title) {
    this.title.setTitle('Apply Docs');
  }

  ngOnInit(): void {

    if (this.assistedService.idNumber) {
      this.blockUI.start();
      this.assistedService.validate().subscribe(() => {
        this.cdkStepper.next();
        this.blockUI.stop();
      }, (error: HttpErrorResponse) => {
        this.blockUI.stop();
        this.gaService.exception(error.error?.message, true);
        if (error.status === 400) {
          this.documents = JSON.parse(JSON.stringify(error.error));
          this.errorMessage = JSON.parse(JSON.stringify(error.error));
          if (this.errorMessage.code || this.errorMessage.message) {
            this.matSnackBar.open(this.errorMessage.message, 'Okay', {
              duration: 5000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          } else {
            this.applicationsService.updateApplicationService(this.documents);
          }
        } else if (error.status === 401) {
          this.router.navigate(['/']);
          this.matSnackBar.open('Your session has expired', 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        } else {
          this.matSnackBar.open(error.error.message, 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
      });
    } else {
      this.blockUI.start();
      this.applicationsService.validate().subscribe(() => {
        this.cdkStepper.next();
        this.blockUI.stop();
      }, (error: HttpErrorResponse) => {
        this.blockUI.stop();
        this.gaService.exception(error.error?.message, true);
        if (error.status === 400) {
          this.documents = JSON.parse(JSON.stringify(error.error));
          console.log(this.documents);
          this.errorMessage = JSON.parse(JSON.stringify(error.error));
          if (this.errorMessage.code || this.errorMessage.message) {
            this.matSnackBar.open(this.errorMessage.message, 'Okay', {
              duration: 5000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          } else {
            this.applicationsService.application.mother = new Spouse();
            this.applicationsService.application.father = new Spouse();
            this.applicationsService.application.guardian = new Spouse();
            this.applicationsService.application.spouse = new Spouse();
            this.applicationsService.application.vulnerableChildOrNonSassDeclaration = null;
            this.applicationsService.application.disabilityAnnexure = null;
            this.applicationsService.application.provisionalOfferLetter = null;
            if (this.documents.mother) {
              this.applicationsService.application.mother = this.documents.mother;
            } else {

            }
            if (this.documents.father) {
              this.applicationsService.application.father = this.documents.father;
            }
            if (this.documents.guardian) {
              this.applicationsService.application.guardian = this.documents.guardian;
            }
            if (this.documents.spouse) {
              this.applicationsService.application.spouse = this.documents.spouse;
            }
            if (this.documents.requiredDocuments) {
              this.documents.requiredDocuments.forEach((attachment: Attachment) => {
                if (attachment.documentType === 'VULNERABLE_CHILD_OR_NON_SASSA_DECLARATION') {
                  this.applicationsService.application.vulnerableChildOrNonSassDeclaration = attachment;
                } else if (attachment.documentType === 'DISABILITY_ANNEXURE') {
                  this.applicationsService.application.disabilityAnnexure = attachment;
                } else if (attachment.documentType === 'PROVISIONAL_OFFER_LETTER') {
                  this.applicationsService.application.provisionalOfferLetter = attachment;
                } else if (attachment.documentType === 'SARS_CONSENT_FORM') {
                  this.applicationsService.application.consentForm = attachment;
                }
              })
            }
            console.log(this.applicationsService.application);
          }
        } else if (error.status === 401) {
          this.router.navigate(['/']);
          this.matSnackBar.open('Your session has expired', 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        } else {
          this.matSnackBar.open(error.error.message, 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
      });
    }
  }

  onFileSelected(event: any) {

    const files: FileList = event.target.files;
    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const extension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (!this.allowedFileTypes.includes(extension)) {
          this.showError(
            `File ${file.name} is not allowed. Permitted types: ${this.allowedFileTypes.join(', ')}`
          );
          event.target.value = '';
          return;
        }

        if (file.size > this.maxFileSize) {
          this.showError(
            `File ${file.name} exceeds the maximum size of ${this.maxFileSize / (1024 * 1024)} MB`
          );
          event.target.value = '';
          return;
        }
      }
    }
  }

  private showError(message: string) {
    this.matSnackBar.open(message, 'Okay', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }


  previous() {
    this.cdkStepper.previous();
  }

  onSubmit() {

    const that = this;
    if (!this.documentForm.valid) {
      this.validated = true;
      $('html, body').animate({
        scrollTop: 0
      }, 1000, function () {
      });
      return;
    } else {
      let valid = true;
      if (this.applicationsService.application.disabilityAnnexure && !this.applicationsService.application.disabilityAnnexure.file) {
        valid = false;
        that.matSnackBar.open('Disability Annexure is required', 'Okay', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
      if (this.applicationsService.application.provisionalOfferLetter && !this.applicationsService.application.provisionalOfferLetter.file) {
        valid = false;
        that.matSnackBar.open('Provisional Offer Letter is required', 'Okay', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
      if (this.applicationsService.application.vulnerableChildOrNonSassDeclaration && !this.applicationsService.application.vulnerableChildOrNonSassDeclaration.file) {
        valid = false;
        that.matSnackBar.open('NSFAS Declaration Form is required', 'Okay', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
      if (this.applicationsService.application.consentForm && !this.applicationsService.application.consentForm.file) {
        valid = false;
        that.matSnackBar.open('Consent Form is required', 'Okay', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
        });
      }
      if (this.applicationsService.application.mother && this.applicationsService.application.spouse.requiredDocuments) {
        this.applicationsService.application.mother.requiredDocuments.forEach((attachment: Attachment) => {
          if (!attachment.file) {
            valid = false;
            that.matSnackBar.open(attachment.caption + ' is required', 'Okay', {
              duration: 5000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          }
        })
      }
      if (this.applicationsService.application.father && this.applicationsService.application.father.requiredDocuments) {
        this.applicationsService.application.father.requiredDocuments.forEach((attachment: Attachment) => {
          if (!attachment.file) {
            valid = false;
            that.matSnackBar.open(attachment.caption + ' is required', 'Okay', {
              duration: 5000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          }
        })
      }
      if (this.applicationsService.application.guardian && this.applicationsService.application.guardian.requiredDocuments) {
        this.applicationsService.application.guardian.requiredDocuments.forEach((attachment: Attachment) => {
          if (!attachment.file) {
            valid = false;
            that.matSnackBar.open(attachment.caption + ' is required', 'Okay', {
              duration: 5000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          }
        })
      }
      if (this.applicationsService.application.spouse && this.applicationsService.application.spouse.requiredDocuments) {
        this.applicationsService.application.spouse.requiredDocuments.forEach((attachment: Attachment) => {
          if (!attachment.file) {
            valid = false;
            that.matSnackBar.open(attachment.caption + ' is required', 'Okay', {
              duration: 5000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });
          }
        })
      }
      if (valid === true) {
        this.cdkStepper.next();
      }
    }
  }


}
